import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=7212f76d&"
import script from "./Confirmation.vue?vue&type=script&lang=js&"
export * from "./Confirmation.vue?vue&type=script&lang=js&"
import style0 from "./Confirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.hva/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormInput, BCol, BRow, BCard, BTable, BButton, BForm, BContainer} from 'bootstrap-vue'
    installComponents(component, {BFormInput, BCol, BRow, BCard, BTable, BButton, BForm, BContainer})
    

export default component.exports